import {getObjectFromSession} from "../../sharedGlobal";

/**
 * The default state of the addon manager on page load.
 */
const defaultState = () => ({
  resaleAddons: [],
  addons: getObjectFromSession(moduleNamespace, 'addons') ?? {},
  errors: {},
});

import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import {moduleNamespace} from "./constants";
export default {
  namespaced: true,
  state: defaultState(),
  getters,
  actions,
  mutations,
};
